import "vant/es/image-preview/style";
import _ImagePreview from "vant/es/image-preview";
import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.array.map.js";
/*
 * @Author: ppttfish@163.com
 * @LastEditors: ppttfish@163.com
 * @Date: 2023-04-06 10:15:53
 * @LastEditTime: 2023-06-27 14:52:54
 */
export var useImagePreview = function useImagePreview() {
  var handleImgPreview = function handleImgPreview(urlList, index) {
    if (!urlList) {
      throw Error('传入的图片列表不能为空');
    }
    var images = urlList.map(function (item) {
      return item.url || item;
    });
    _ImagePreview({
      images: images,
      startPosition: index
    });
  };
  return {
    handleImgPreview: handleImgPreview
  };
};